/* eslint-disable */
export default {
  dialer: '다이얼패드',
  allCalls: '모든 통화',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
